import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PivotTableComponent } from '../pivot-table/pivot-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CustomCheckboxdropdownModule } from 'src/app/shared/components/custom-checkboxdropdown/custom-checkboxdropdown.module';
import { PivotTableRoutingModule } from './pivot-table-routing.module';
import { ChSkeletonComponent } from '../shared/ch-skeleton/ch-skeleton.component';



@NgModule({
  declarations: [
    PivotTableComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,  
        FormsModule,
        CustomCheckboxdropdownModule,
            ReactiveFormsModule,
            CustomDropdownModule,
            CustomDatePickerModule,
            MaterialModule,
            CustomTimpickerModule,
            CustomInputModule,
            MatPaginatorModule,
            PivotTableRoutingModule,
            ChSkeletonComponent
  ],
   exports: [
    PivotTableComponent 
  ]
})
export class PivotTableModule { }
